import { render, staticRenderFns } from "./page-portfolio-detail.vue?vue&type=template&id=4da2011b&"
import script from "./page-portfolio-detail.vue?vue&type=script&lang=js&"
export * from "./page-portfolio-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports